import { Box, Text } from "@chakra-ui/react";
import { CrashType, Score } from "@keita/lanepatrol-sdk";
import i18next from "i18next";
import { Dispatch, SetStateAction, useState } from "react";
import { RiskFactorSelector } from "./RiskFactorSelector";
import { ScoreFilterItem } from "./ScoreFilterItem";
import { ScoreFilterHeader } from "./ScoreFilterHeader";
import {
  ScoreFilter,
  ScoreFilterType,
  ResultsScoreLimits,
} from "../../../../../map/models/MapFilters";
import { tScoreType } from "../../../../../coding/utils/score-utils";

const crashTypes = Object.values(CrashType);

const getInitialShowRangeValue = (filter: Map<keyof Score, ScoreFilter>) =>
  !crashTypes.find(
    (crashType) => filter.get(crashType)?.type === ScoreFilterType.RiskFactors
  );

interface Props {
  filters: Map<keyof Score, ScoreFilter>;
  setFilters: Dispatch<SetStateAction<Map<keyof Score, ScoreFilter>>>;
  limits: Map<string, ResultsScoreLimits>;
}
export const CrashTypeScoreFilter: React.FC<Props> = ({
  filters,
  setFilters,
  limits,
}) => {
  const [showRange, setShowRange] = useState(() =>
    getInitialShowRangeValue(filters)
  );

  const handleChange = (key: keyof Score, value: ScoreFilter) => {
    setFilters((prev) => {
      for (const key of crashTypes) {
        const prevValue = prev.get(key);
        if (prevValue && prevValue.type !== value.type) {
          prev.delete(key);
        }
      }
      prev.set(key, value);
      return new Map(prev);
    });
  };

  return (
    <>
      <ScoreFilterHeader
        title={i18next.t("map:filters.score.byCrashTypeNodeTitle")}
        showRange={showRange}
        setShowRange={setShowRange}
      />
      {crashTypes.map((crashType, i) => (
        <Box key={i} my={4}>
          <Text fontSize="sm">{tScoreType(crashType)}</Text>
          {showRange ? (
            <ScoreFilterItem
              limit={limits.get(crashType)!}
              filter={filters.get(crashType)}
              setFilter={(value) => handleChange(crashType, value)}
              crashType={crashType}
              key={i}
            />
          ) : (
            <RiskFactorSelector
              filter={filters.get(crashType)}
              setFilter={(value) => handleChange(crashType, value)}
            />
          )}
        </Box>
      ))}
    </>
  );
};
